import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const links = [
  { to: '/',            label: 'Home' },
  { to: '/services',    label: 'Services' },
  { to: '/case-studies',label: 'Case Studies' },
  { to: '/open-source', label: 'Open Source' },
  { to: '/resources',   label: 'Resources' },
  { to: '/blog',        label: 'Blog' },
  { to: '/about',       label: 'About' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', h);
    return () => window.removeEventListener('scroll', h);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <Link to="/" className="nav-logo">
          <img src={logo} alt="arhatinfo logo" className="nav-logo-img" />
          <span className="nav-logo-text">
            Arhat<span className="tld">Info</span>
          </span>
        </Link>

        <ul className="nav-links">
          {links.map(({ to, label }) => (
            <li key={to}>
              <Link to={to} className={pathname === to ? 'active' : ''}>
                {label}
              </Link>
            </li>
          ))}
          <li>
            <Link to="/contact" className="nav-cta">Book a Call</Link>
          </li>
        </ul>

        <button className="nav-ham" onClick={() => setOpen(!open)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </nav>

      <div className={`nav-mobile${open ? ' open' : ''}`}>
        {links.map(({ to, label }) => (
          <Link key={to} to={to}>{label}</Link>
        ))}
        <Link to="/contact" className="nav-cta" style={{ marginTop: '.5rem' }}>
          Book a Call
        </Link>
      </div>
    </>
  );
}
